import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(theme => ({
  container: {
    paddingLeft: "20%",
  },
  activatedIcon: {
    color: theme.palette.success.main,
  },
  deactivatedIcon: {
    color: theme.palette.error.main,
  },
}));

/**
 * Displays an activated/deactivated status
 * @param {string} property - The property name to check for the deactivated status
 * @param {object} record - The record object containing the user data
 */
const ActivatedBooleanField = ({ property, record = {} }) => {
  const styles = useStyles();

  const isActivated = !record[property];

  return (
    <div className={styles.container}>
      {isActivated ? (
        <CheckIcon
          className={styles.activatedIcon}
          titleAccess="Activated"
          aria-label="User is activated"
        />
      ) : (
        <CloseIcon
          className={styles.deactivatedIcon}
          titleAccess="Deactivated"
          aria-label="User is deactivated"
        />
      )}
    </div>
  );
};

ActivatedBooleanField.propTypes = {
  property: PropTypes.string.isRequired,
  record: PropTypes.object,
};

ActivatedBooleanField.defaultProps = {
  record: {},
};

export default ActivatedBooleanField;
